import { createContext } from "react";

const defaultContext = { preview: false };
export const PreviewContext = createContext(defaultContext);
PreviewContext.displayName = "PreviewContext";
